import { Evaluate } from '@/plugins/api'

export default {
  namespaced: true,

  state: {
    evaluates: [],
    evaluate: null,
    loading: false,
    error: null,
    total: 0,
    statistics: null,
  },

  mutations: {
    SET_EVALUATES(state, evaluates) {
      state.evaluates = evaluates
    },
    SET_EVALUATE(state, evaluate) {
      state.evaluate = evaluate
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_TOTAL(state, total) {
      state.total = total
    },
    SET_STATISTICS(state, statistics) {
      state.statistics = statistics
    },
  },

  actions: {
    async fetchEvaluates({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await Evaluate.fetch(params)
        commit('SET_EVALUATES', response)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchEvaluate({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const response = await Evaluate.fetchOne(id)
        commit('SET_EVALUATE', response)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createEvaluate({ commit }, evaluateData) {
      commit('SET_LOADING', true)
      try {
        const response = await Evaluate.create(evaluateData)
        commit('SET_EVALUATE', response)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateEvaluate({ commit }, { id, evaluateData }) {
      commit('SET_LOADING', true)
      try {
        const response = await Evaluate.update(id, evaluateData)
        commit('SET_EVALUATE', response)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteEvaluate({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        await Evaluate.remove(id)
        commit('SET_EVALUATE', null)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async countEvaluates({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const total = await Evaluate.count(params)
        commit('SET_TOTAL', total)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async generateEvaluate({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await Evaluate.generateEvaluate(params)
        commit('SET_EVALUATE', response)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async statisticEvaluate({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await Evaluate.statisticEvaluate(params)
        commit('SET_STATISTICS', response)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },

  getters: {
    getEvaluates: (state) => state.evaluates,
    getEvaluate: (state) => state.evaluate,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
    getTotal: (state) => state.total,
    getStatistics: (state) => state.statistics,
  },
}
